import { useAuthStoreUser, UserAuthStore } from "@/stores/app/authUser";
import { computed, ref } from "vue";

// Fonte única da verdade para "esta conta comprou/tem acesso ao Clone".
// TODO(backend): hoje deriva de ResponseConta.clonePurchased, que ainda não existe na API
// (ver TODO em contas.service.ts). Quando o backend expuser o campo real, só este arquivo
// precisa ser ajustado — onboarding, modal dedicado e upsell todos leem daqui.
export function cHasCloneAccess(authStore?: UserAuthStore) {
    if (!authStore) authStore = useAuthStoreUser();

    const __debugForceHasCloneAccess = ref(false);

    // Atalho de teste sem precisar do Vue Devtools: no console do navegador,
    // localStorage.setItem('whiz:debug:clonePurchased', 'true') e recarregue a página.
    const debugLocalStorageOverride = localStorage.getItem('whiz:debug:clonePurchased') === 'true';

    const hasCloneAccess = computed(() =>
        __debugForceHasCloneAccess.value ||
        debugLocalStorageOverride ||
        !!authStore.currentAccountHasAtLeastOneInboxWithAiAgent
    );

    return {
        __debugForceHasCloneAccess,
        hasCloneAccess
    }
}
